module.exports = __webpack_public_path__ + "70cc5f6cc436db34dee343d69a387c7a.svg";